import { setConsentToProcessError } from '../reducers/gdpr';
export function dismissConsentToProcessError() {
  return dispatch => {
    dispatch(setConsentToProcessError(false));
  };
}